export type Bonus = {
  n: string
  title: string
  description: string
  price: string
  cover: string
}

export const bonuses: Bonus[] = [
  {
    n: '01',
    title: 'El Canal del Infinito',
    description: 'Fisiología Energética y Reloj Biológico de los Meridianos',
    price: '$15.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/9Fg1u8KcYnsDLL6iZNZzGg/Portada_bono_1.png',
  },
  {
    n: '02',
    title: 'Psicosomática Oriental',
    description: 'El Mapa de las Emociones Atrapadas y los 5 Elementos',
    price: '$15.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/mFbheBuV92EbBHCzYXpiE9/Portada_bono_2.png',
  },
  {
    n: '03',
    title: 'Maestría en Manipulación',
    description: 'Ciencia, Intención y Técnica de la Presión Energética',
    price: '$12.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/3hiCDxviJ8RJyEzYBYpYFS/Portada_bono_3.png',
  },
  {
    n: '04',
    title: 'Alquimia a través del Calor',
    description: 'Termoterapia y Moxibustión aplicada a los Puntos Maestros',
    price: '$12.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/my1xAMXdFbnyeWbhRpBkXa/Portada_bono_4.png',
  },
  {
    n: '05',
    title: 'Auriculoterapia Clínica',
    description:
      'El Microsistema del Pabellón Auricular: el mando a distancia de tu salud',
    price: '$12.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/gM1x7anh6bgMK5Qmz1e3Lh/Portada_bono_5_.png',
  },
  {
    n: '06',
    title: 'Farmacopea Externa',
    description:
      'Sinergia Holística: Aceites Esenciales y Plantas aplicadas a los Puntos Maestros',
    price: '$10.000',
    cover:
      'https://cdn.magicpatterns.com/uploads/fE84NG1BYY6G35N1haofmi/Portada_bono_6.png',
  },
]

export type Tome = {
  numeral: string
  label: string
  title: string
  description: string
  cover: string
}

export const tomes: Tome[] = [
  {
    numeral: '壹',
    label: 'Tomo I',
    title: 'El Mapa de los Meridianos Maestros',
    description:
      'Los 12 meridianos principales y los 8 vasos extraordinarios. Cada meridiano con su visual anatómico completo, recorrido marcado punto a punto, tabla clínica de referencia rápida y reloj biológico de actividad.',
    cover:
      'https://cdn.magicpatterns.com/uploads/4b9ZXnPZHRFPL1Vw3UA7j5/Portada_tomo_1.png',
  },
  {
    numeral: '貳',
    label: 'Tomo II',
    title: 'Protocolos de Respuesta Inmediata',
    description:
      '26 patologías organizadas en 6 secciones clínicas. Cada protocolo con imagen anatómica del área tratada, puntos exactos marcados sobre la ilustración, técnica específica, diagnóstico diferencial según la MTC y contraindicaciones.',
    cover:
      'https://cdn.magicpatterns.com/uploads/iZHRLGd7uQPLESo9eVtfY3/Portada_tomo_2.png',
  },
  {
    numeral: '參',
    label: 'Tomo III',
    title: 'El Arte de la Aguja',
    description:
      'Técnicas maestras de manipulación: De-Qi, tonificación, dispersión, moxa, electroacupuntura, seguridad clínica y el camino del terapeuta maestro.',
    cover:
      'https://cdn.magicpatterns.com/uploads/aRsARbgTTjmSUquhqazrqp/Portada_tomo_3.png',
  },
]
